export const DataMutation_DeleteCustomerAddress_QueryKey = {
  deleteCustomerAddress: (): string => {
    const queryKey = "data-mutation--delete-customer-address";
    return queryKey;
  },
};
